import { t } from 'ember-intl'
import type { TOC } from '@ember/component/template-only'
import {
  InlineAlert,
  AlertType,
  InlineAlertSubtitle,
  InlineAlertTitle,
} from 'teacher-ui-client/components/inline-alert'

interface Signature {
  Element: HTMLDivElement
  Args: {
    show: boolean
  }
}

/**
 * only meant for / going to be seen by subcos.
 **/
export const TrialTeacherAlert: TOC<Signature> = <template>
  {{#if @show}}
    <InlineAlert data-test-trial-teacher-alert @type={{AlertType.Warning}} ...attributes>
      <InlineAlertTitle>
        {{t "components.copyClasses.trialTeacher.problem.subco"}}
      </InlineAlertTitle>
      <InlineAlertSubtitle>
        {{t "components.copyClasses.trialTeacher.solution.subco"}}
      </InlineAlertSubtitle>
    </InlineAlert>
  {{/if}}
</template>
